export default __webpack_public_path__ + "static/federations-mobile-ffe045f90d752ffed1c6cde5160ad4b5.svg";